import { FeatureHash } from './feature-toggle-list';

//

type Overrides = {
  toggles :FeatureHash;
  environment :Record<string, string>;
};

const storageKey = '__luminousOverrides';

//

export const envList = [
  { key: 'develop', name: 'Develop' },
  { key: 'localbackend', name: 'Local Backend' },
  { key: 'staging', name: 'Staging' },
];

// todo remove this once the backend implements env override query param
export const envOverrides = {
  develop: {
    url: 'https://staging-old.api.xjimports.com/api/admin',
    urlV2: 'https://staging-old.api.xjimports.com/v2/api/admin',
    logRocketAppId: 'badabing-instance',
    versionCheckURL: 'https://staging-old.luminousolutions.com/assets/version.json',
    clientConfig: {
      assetImgDir: '/assets/luminous/img/',
      b2bPortal: 'https://dm9dv21j4tz0y.cloudfront.net/',
      className: 'luminous',
      companyName: 'Luminous, Inc.',
      email: 'contact@luminousolutions.com',
      name: 'Badabing',
      phone: ' +1-435-480-1295',
    },
    ECHO_CONFIG: {
      authEndpoint:
        'https://staging-old.api.xjimports.com/api/admin/broadcasting/auth',
      broadcaster: 'pusher',
      disableStats: true,
      host: 'https://staging-old.api.xjimports.com',
      key: 'XJIMPORTS',
      wsHost: 'staging-old.api.xjimports.com',
    },
  },
  localbackend: {
    url: 'http://test.localhost:8000/api/admin',
    urlV2: 'http://test.localhost:8000/v2/api/admin',
    logRocketAppId: 'localbackend',
    versionCheckURL: 'http://test.localhost:8000/assets/version.json',
    clientConfig: {
      assetImgDir: '/assets/luminous/img/',
      b2bPortal: 'https://dm9dv21j4tz0y.cloudfront.net/',
      className: 'luminous',
      companyName: 'Luminous, Inc.',
      email: 'contact@luminousolutions.com',
      name: 'Badabing',
      phone: ' +1-435-480-1295',
    },
    ECHO_CONFIG: {
      authEndpoint: 'http://test.localhost:8000/api/admin/broadcasting/auth',
      broadcaster: 'pusher',
      disableStats: true,
      host: 'http://test.localhost:8000',
      key: 'XJIMPORTS',
      wsHost: 'http://test.localhost:8000',
    },
  },
  staging: {
    url: 'https://staging.api.xjimports.com/api/admin',
    urlV2: 'https://staging.api.xjimports.com/v2/api/admin',
    versionCheckURL: 'https://staging.luminousolutions.com/assets/version.json',
    logRocketAppId: 'luminous-staging-instance',
    clientConfig: {
      name: 'Luminous Staging',
      companyName: 'Luminous Staging',
      className: 'luminous',
      phone: ' +1-435-480-1295',
      email: 'contact@luminous.com',
      assetImgDir: '/assets/luminous/img/',
      b2bPortal: 'https://staging.portal.luminousolutions.com/',
      subscriptionType: 'pro',
    },
    ECHO_CONFIG: {
      broadcaster: 'pusher',
      key: 'LUMINOUS',
      wsHost: 'staging.luminousolutions.com',
      auth: {},
      authEndpoint: 'https://staging.api.xjimports.com/api/admin/broadcasting/auth',
      host: 'https://staging.api.xjimports.com',
      wsPort: 6001,
      wssPort: 6001,
      // statsHost: 'https://staging.api.xjimports.com/laravel-websockets',
      disableStats: true,
      forceTLS: true,
      encrypted: true,
      enabledTransports: ['ws', 'wss'],
    },
  },
};

export function getDefaultEnvName() :string {
  switch (location.hostname) {
    case 'staging.luminousolutions.com':
      return 'staging';
    default:
      return 'develop';
  }
}

export function getOverride() :Overrides {
  let overrides :Overrides;
  const empty :Overrides = { toggles: <FeatureHash>{}, environment: {} };
  try {
    overrides = JSON.parse(localStorage.getItem(storageKey)) || empty;
  } catch (e) {
    localStorage.setItem(storageKey, JSON.stringify(empty));
    overrides = empty;
  }

  return overrides;
}

export function saveOverride(key :string, value :any) :void {
  const overrides = getOverride();
  overrides[key] = value;
  localStorage.setItem(storageKey, JSON.stringify(overrides));
}

export function clearOverride() {
  localStorage.removeItem(storageKey);
}

export function getUnconfiguredApiUrl() :string | void {
  if (
    getDefaultEnvName() === 'develop' &&
    location.hostname.match(/([a-z0-9]+[.])luminousolutions[.]com/)
  ) {
    return `https://${location.hostname.replace(
      '.luminousolutions.com',
      '.api.xjimports.com/api',
    )}`;
  } else if (location.hostname.match(/([a-z0-9]+[.])joinluminous[.]com/)) {
    return `https://${location.hostname.replace(
      '.joinluminous.com',
      '.api.xjimports.com/api',
    )}`;
  }
}
